import React from "react";
import { Spinner } from "spot-component-library/lib/components/basic/spinner/Spinner";
import rateAgreementService from "../../services/RateAgreementService";
import { ErrorPage } from "../ErrorPage/ErrorPage";
import "./ErrorSubscription.scss";

import { useTranslation } from "react-i18next";
import { DebtNumberError } from "../../types/errors/DebtNumberError";
import { AboMandateStatus } from "../../types/AboMandateStatus";
import { useNavigate } from "../../components/router/Router";
import { getComputopUrlParams } from "../../utils/computop";
import { Etracker } from "spot-component-library/lib/components/etracker/Etracker";
import { readLanguageFromCookie } from "../../utils/helper";
import { SPOTNotification } from "spot-component-library/lib/components/notification/SPOTNotification";
import { useTenant } from "../../contexts/TenantContext";

export const ErrorSubscription = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [isPageLoaded, setIsPageLoaded] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>();
    const [aboMandateStatus, setAboMandateStatus] = React.useState<AboMandateStatus>();
    const { tenant } = useTenant();

    React.useEffect(() => {
        initData().then(() => setIsPageLoaded(true));
    }, []);

    async function initData() {
        const { data } = getComputopUrlParams();

        if (!data) {
            return;
        }

        try {
            const aboMandateStatus = await rateAgreementService.getAboMandateStatus(data);
            setAboMandateStatus(aboMandateStatus);
        } catch (e) {
            if (e instanceof DebtNumberError) {
                setErrorMessage(t("APP_ROOT.ERROR.DEBT_NUMBER_INVALID"));
            }

            setErrorMessage(t("APP_ROOT.ERROR.SERVER_MESSAGE_DEFAULT"));
        }
    }

    async function handlePrimaryButtonClick() {
        if (!aboMandateStatus?.rateAgreementId || !aboMandateStatus.debtNo) {
            setErrorMessage(t("APP_ROOT.ERROR.SERVER_MESSAGE_DEFAULT"));
            return;
        }

        try {
            const payGateUrl = await rateAgreementService.getPayGateUrl(aboMandateStatus);
            window.location.href = payGateUrl.url;
        } catch (e) {
            if (e instanceof DebtNumberError) {
                setErrorMessage(t("APP_ROOT.ERROR.DEBT_NUMBER_INVALID"));
            }

            setErrorMessage(t("APP_ROOT.ERROR.SERVER_MESSAGE_DEFAULT"));
        }
    }

    return (
        <>
            {tenant?.name && <Etracker pageName={"RateAgreement-ABOError"} popto={"1500"} tenant={tenant.name} language={readLanguageFromCookie()} />}

            {isPageLoaded && (
                <>
                    {!errorMessage && (
                        <div data-test="ErrorSubscription">
                            <ErrorPage
                                errorCode={aboMandateStatus?.paymentCode}
                                onPrimaryButtonClick={aboMandateStatus && handlePrimaryButtonClick}
                                onSecondaryButtonClick={() => navigate({ to: "" })}
                            />
                        </div>
                    )}

                    {errorMessage && (
                        <div style={{ paddingTop: 10 }}>
                            <SPOTNotification type="error" active={true} text={errorMessage}></SPOTNotification>
                        </div>
                    )}
                </>
            )}
            <Spinner isLoading={!isPageLoaded} type="page" color={"grey"} />
        </>
    );
};
